module.exports = __webpack_public_path__ + "media/images/pepsi_digin_brunch_lv/blue-bg-02d7f542ae16d72dff08e85d05f4bd01.png";